<div style="width: 100%;background-color: #dee8f4;padding: 10px">
  <form #loginForm="ngForm">
    <div *ngFor="let group of validFilters;">
      <h4 mat-line>{{group.title}}</h4>
      <div *ngFor="let input of group.inputs" [ngSwitch]="input.type">
        <div *ngSwitchCase="'checkbox'">
          <mat-checkbox *ngFor="let value of input.values" style="margin-right: 1em;"
            [(ngModel)]="filterModel[value.name]" name="{{value.name}}"
            ngDefaultControl
          >
              {{value.text}}
          </mat-checkbox> 
        </div>
        <div *ngSwitchCase="'text'" style="min-width: 33%; display: flex; flex: 1 1 auto;">
          <mat-form-field *ngFor="let value of input.values">
           <input matInput
            style="flex-grow: 1; flex-basis: 0;"
            [attr.list]="value.autocomplete ? value.autocomplete : null "
            name="{{value.name}}" [(ngModel)]="filterModel[value.name]"
            placeholder="{{value.text}}" 
            ngDefaultControl/>
          </mat-form-field>
          <div style="float:right;clear:none;width:100px">
            <button matTooltip="{{ 'common.cerca' | translate }}" attr.aria-label="{{ 'common.cerca' | translate }}" matTooltipClass="tooltip-style" mat-button style="min-width:45px;padding:10px" (click)="sendActiveFilters()">
            <mat-icon color="primary" style="font-size: 24px">search</mat-icon>
            </button>
            <button matTooltip="{{ 'common.reinicia' | translate }}" attr.aria-label="{{ 'common.reinicia' | translate }}" matTooltipClass="tooltip-style" mat-button style="min-width:45px;padding:10px" (click)="resetActiveFilters()">
            <mat-icon color="primary" style="font-size: 24px">autorenew</mat-icon>
            </button>
          </div>
        </div>
        <label *ngSwitchCase="'select'" style="max-width: 33%; display: flex; flex-grow: 1; flex-basis: 0;">
          {{input.description}}
          <mat-select [(ngModel)]="filterModel[input.name]" name="{{input.name}}" ngDefaultControl>
            <mat-option *ngFor="let option of input.options"  value="{{option.value}}">{{option.text}}</mat-option>
          </mat-select>
        </label>
      </div>
    </div>
  </form>
</div>
<div *ngFor="let dataList of dataLists">
  <datalist id="{{dataList.id}}">
    <option *ngFor="let option of dataList.options | async" value="{{option.value}}">{{option.text}}</option>
  </datalist>
</div>
